import { AlertTriangle, Info, ShieldAlert } from 'lucide-react';
import { Badge, type BadgeTone } from './Badge';
import type { DriftSeverity } from '@/hooks/useDriftReport';

const toneByLevel: Record<DriftSeverity, BadgeTone> = {
  info: 'neutral',
  warning: 'warning',
  critical: 'danger',
};

const labelByLevel: Record<DriftSeverity, string> = {
  info: 'OK',
  warning: 'Drift',
  critical: 'Kritisch',
};

interface SeverityBadgeProps {
  severity: DriftSeverity;
  /** Custom label (default: lokalisierte Form). */
  label?: string;
  className?: string;
}

/**
 * Severity-Badge für das Drift-Dashboard und ahnliche Listen.
 *
 *   info     -> grau   ("OK", in-sync)
 *   warning  -> gelb   ("Drift", minor lag)
 *   critical -> rot    ("Kritisch", major lag oder EOL)
 *
 * Icon ist intentional klein (size-3) und decorative (aria-hidden).
 * Das Badge selbst wirkt durch die Farbe und das Label semantisch.
 */
export function SeverityBadge({
  severity,
  label,
  className,
}: SeverityBadgeProps): JSX.Element {
  const tone = toneByLevel[severity];
  const text = label ?? labelByLevel[severity];
  const Icon =
    severity === 'critical' ? ShieldAlert : severity === 'warning' ? AlertTriangle : Info;
  return (
    <Badge tone={tone} {...(className ? { className } : {})}>
      <Icon className="mr-1 inline size-3" aria-hidden="true" />
      <span>{text}</span>
    </Badge>
  );
}
